import { manifestFragments } from "@/assets/requirements";
import { APP_AUDIO_CATALOG } from "@/audio/app-catalog";
import { LEVEL_REGISTRY } from "@/content/registry";
import {
  VisitedIslandOfflineCoordinator,
  type OfflineUpdateSafetyController
} from "@/features/offline";
import { pwaController } from "@/platform/pwa";

const updateSafety: OfflineUpdateSafetyController = {
  setUpdateSafe: (isUpdateSafe) => {
    pwaController.setUpdateSafe(isUpdateSafe);
  },
  reportCacheFailure: (reason) => {
    pwaController.reportCacheFailure(reason);
  },
  reportCacheReady: () => {
    pwaController.dismissCacheFailure();
  }
};

// The shell is an update-safe boundary until a real play identity is accepted.
pwaController.setUpdateSafe(true);

export const appOfflineCoordinator = new VisitedIslandOfflineCoordinator({
  resourceCatalog: {
    assetFragments: manifestFragments,
    audioCatalog: APP_AUDIO_CATALOG,
    validatedLevels: LEVEL_REGISTRY
  },
  updateSafety
});
